import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitPhotos = async ({
  visitId,
  patientId,
  sessionId,
  stepId,
  extraPhotos,
  isAllPhotos,
  disallowInvPhotosSelection,
  applyPhotosToFollowing,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);
  if (stepId) params.append("step_id", stepId);

  const payload = { extra_photos: extraPhotos };
  if (isAllPhotos !== undefined) payload.is_all_photos = isAllPhotos;
  if (disallowInvPhotosSelection !== undefined)
    payload.disallow_inv_photos_selection = disallowInvPhotosSelection;
  if (applyPhotosToFollowing !== undefined)
    payload.apply_photos_to_following = applyPhotosToFollowing;

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/photos/?${params.toString()}`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateVisitPhotosMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitPhotos,
    onSuccess: (_, variables) => {
      toast.success("Photos updated");
      queryClient.invalidateQueries({ queryKey: ["visit_photos", variables.visitId] });
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update photos");
    },
  });
};

export default useUpdateVisitPhotosMutation;
